import React from 'react'
import BaseTooth from './BaseTooth'
import { ToothComponentProps } from './types/tooth.types'

/** Factory for lingual-view tooth components (lower teeth 17–32). */
export const createToothLingual = (
  toothNumber: number,
): React.FC<ToothComponentProps> => {
  const ToothComponent = (props: ToothComponentProps): React.ReactElement => {
    return <BaseTooth toothNumber={toothNumber} view="lingual" {...props} />
  }
  ToothComponent.displayName = `ToothLingual${toothNumber}`
  return ToothComponent
}
